import React from 'react';
import AudioPlayer from './AudioPlayer';
import Figure from './Figure';
import Image from './Image';
import FigureList from './FigureList';
import MathJax from './MathJax';
import Table from './Table';
import Row from './Row';
import TaskCallout from './TaskCallout';
import TaskCarousel from './TaskCarousel';
import TaskChordBuilder from './TaskChordBuilder';
import TaskCustom from './TaskCustom';
import TaskDragDrop from './TaskDragDrop';
import TaskFreeResponse from './TaskFreeResponse';
import TaskGraphSliderConfigurable from './TaskGraphSliderConfigurable';
import TaskImageClick from './TaskImageClick';
import TaskLikertScale from './TaskLikertScale';
import TaskMultiChoice from './TaskMultiChoice';
import TaskMultiSelect from './TaskMultiSelect';
import TaskMultiSelectSubmit from './TaskMultiSelectSubmit';
import TaskPassageClick from './TaskPassageClick';
import TaskPassageReveal from './TaskPassageReveal';
import TaskScaleBuilder from './TaskScaleBuilder';
import TaskSelect from './TaskSelect';
import TaskDropdownMulti from './TaskDropdownMulti';
import TaskSorting from './TaskSorting';
import TaskTabPanel from './TaskTabPanel';
import TaskTree from './TaskTree';
import TaskTrueFalse from './TaskTrueFalse';
import TaskVoiceBuilder from './TaskVoiceBuilder';
import TaskMusicPlayer from './TaskMusicPlayer';
import TaskMusicViewer from './TaskMusicViewer';
import DesignRow from './DesignRow';
import Paragraph from './Paragraph';
import VideoPlayer from './VideoPlayer';
import "./index.css";
const e = {
  AudioPlayer,
  DesignRow,
  Figure,
  FigureList,
  Image,
  MathJax,
  Table,
  Paragraph,
  Row,
  TaskCallout,
  TaskCarousel,
  TaskChordBuilder,
  TaskCustom,
  TaskDragDrop,
  TaskDropdownMulti,
  TaskFreeResponse,
  TaskGraphSliderConfigurable,
  TaskImageClick,
  TaskLikertScale,
  TaskMultiChoice,
  TaskMultiSelect,
  TaskMultiSelectSubmit,
  TaskMusicPlayer,
  TaskMusicViewer,
  TaskPassageClick,
  TaskPassageReveal,
  TaskScaleBuilder,
  TaskSelect,
  TaskSorting,
  TaskTabPanel,
  TaskTree,
  TaskTrueFalse,
  TaskVoiceBuilder,
  VideoPlayer
};
export default e;